import { useCallback, useState } from 'react';
import { useEventListener } from '../useEventListener';
import { useIsomorphicLayoutEffect } from '../useIsomorphicLayoutEffect';
const IS_SERVER = typeof window === 'undefined';
export function useElementSize(options = {}) {
    let { initializeWithValue = true } = options;
    if (IS_SERVER) {
        initializeWithValue = false;
    }
    const [ref, setRef] = useState(null);
    const readValue = useCallback(() => {
        var _a, _b;
        return {
            width: (_a = ref === null || ref === void 0 ? void 0 : ref.offsetWidth) !== null && _a !== void 0 ? _a : 0,
            height: (_b = ref === null || ref === void 0 ? void 0 : ref.offsetHeight) !== null && _b !== void 0 ? _b : 0,
        };
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    const [size, setSize] = useState(() => {
        if (initializeWithValue) {
            return readValue();
        }
        return { width: 0, height: 0 };
    });
    const handleSize = useCallback(() => {
        setSize(readValue());
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    useEventListener('resize', handleSize);
    useIsomorphicLayoutEffect(() => {
        handleSize();
    }, [ref === null || ref === void 0 ? void 0 : ref.offsetHeight, ref === null || ref === void 0 ? void 0 : ref.offsetWidth]);
    return [setRef, size];
}
